import styled from 'styled-components';
import { S_Button } from '../../../style/Button.style';

export const S_UploadBtn = styled(S_Button)`
  font-size: 1.8rem;
  font-weight: 500;
`;
